import { Stack, Tooltip } from '@mui/material'

import { memo } from 'react'
import Text from './Text'

const DisplayLabel = ({ title, label, variant, helpText }) => {
  const labelText = <Text label={label} variant={variant} fontWeight={700} />
  return (
    <Stack direction='row' spacing={1}>
      <Text label={`${title}: `} variant={variant} />
      {helpText ? (
        <Tooltip title={helpText}>
          <span>{labelText}</span>
        </Tooltip>
      ) : (
        labelText
      )}
    </Stack>
  )
}

export default memo(DisplayLabel)
